import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Newspaper, User, Tag, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api, { resolveImg } from "@/lib/api";
import { formatDate } from "@/lib/format";
import { useSeo } from "@/hooks/useSeo";
import PageHeader from "@/components/PageHeader";

const BeritaDetail = () => {
  const { slug } = useParams();
  const [n, setN] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useSeo(n?.title || "Berita", n?.excerpt);

  useEffect(() => {
    api.get(`/news/${slug}`).then((r) => setN(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center px-6">
      <p className="text-slate-500">Berita tidak ditemukan.</p>
      <Link to="/berita"><Button variant="outline" className="gap-2 border-emerald-200 text-emerald-700"><ArrowLeft className="h-4 w-4" /> Kembali ke Berita</Button></Link>
    </div>
  );
  if (!n) return <div className="flex min-h-[60vh] items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;

  return (
    <div>
      <PageHeader title={n.title} crumbs={[{ label: "Berita", to: "/berita" }, { label: "Detail" }]} />
      <article className="mx-auto max-w-3xl px-6 py-14">
        <div className="mb-6 flex flex-wrap items-center gap-4 text-sm text-slate-500">
          <span className="flex items-center gap-1.5"><Tag className="h-4 w-4 text-emerald-600" />{n.category}</span>
          <span className="flex items-center gap-1.5"><Newspaper className="h-4 w-4 text-emerald-600" />{formatDate(n.date)}</span>
          <span className="flex items-center gap-1.5"><User className="h-4 w-4 text-emerald-600" />{n.author}</span>
        </div>
        {n.image_url && <img src={resolveImg(n.image_url)} alt={n.title} className="w-full rounded-2xl object-cover shadow-sm" />}
        <div className="prose prose-slate mt-8 max-w-none">
          <p className="text-lg font-medium text-slate-700">{n.excerpt}</p>
          {(n.content || "").split("\n").filter(Boolean).map((para, i) => (
            <p key={i} className="mt-4 leading-relaxed text-slate-600">{para}</p>
          ))}
        </div>
        <div className="mt-10">
          <Link to="/berita"><Button variant="outline" className="gap-2 border-emerald-200 text-emerald-700" data-testid="news-back-button"><ArrowLeft className="h-4 w-4" /> Kembali ke Berita</Button></Link>
        </div>
      </article>
    </div>
  );
};

export default BeritaDetail;
